<script>
import SimOrdersView from './sim_orders/admin_sim_orders_view.svelte';
import SimOrdersModify from './sim_orders/admin_sim_orders_modify.svelte';

import SimActivationsView from './sim_activations/admin_sim_activations_view.svelte';
import SimActivationsModify from './sim_activations/admin_sim_activations_modify.svelte';

import Emails from './email/admin_emails_view.svelte';


import app from './web_feathers.js';
let account;
let password;
let error;
function login(){
	error=null;
	if(!account || !password) return error='You must enter both account information and password.';
	app.login(account,password).catch(e=>error=e);
	}
const {perms, email, userID, checkedToken,checkingToken} = app;

import Router from 'svelte-spa-router';
import { link, location, pop, push} from 'svelte-spa-router';
import active from 'svelte-spa-router/active';

import Fa from 'svelte-fa'
import { faClipboardList, faSimCard, faMapMarkedAlt, faTools, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import passwordNew from './new_password/passwordNew.svelte';
import passwordSet from './new_password/passwordSet.svelte';


const routes = {
    // Exact path
   // '/': , //TODO: make a home dashboard

    // Using named parameters, with last being optional
	'/Emails/:email': Emails,
	'/new_password/:email/:resetToken': passwordSet,
	'/new_password/:information': passwordNew,
	'/new_password': passwordNew,


    // Catch-all
    // This is optional, but if present it must be the last
    //'*': NotFound,
}

const basePaths=['/SimOrders','/SimActivations'];




</script>

<style>
/* Style for "active" links; need to mark this :global because the router adds the class directly */
:global(a.active) {
	font-weight: bold;
	}

.ribbon {
  background-color: #a00;
  overflow: hidden;
  white-space: nowrap;
  /* top left corner */
  position: fixed;
  right: -60px;
  top: 60px;
  /* 45 deg ccw rotation */
  -webkit-transform: rotate(45deg);
     -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
       -o-transform: rotate(45deg);
          transform: rotate(45deg);
  /* shadow */
  -webkit-box-shadow: 0 0 10px #888;
     -moz-box-shadow: 0 0 10px #888;
          box-shadow: 0 0 10px #888;
  }
.ribbon a {
  border: 1px solid #faa;
  color: #fff;
  display: block;
  font: bold 100% 'Helvetica Neue', Helvetica, Arial, sans-serif;
  margin: 1px 0;
  padding: 10px 100px;
  text-align: center;
  text-decoration: none;
  /* shadow */
  text-shadow: 0 0 5px #444;
  }
</style>


<main>
<br>
{#if process.env.NODE_ENV=='test'}
	<div class="ribbon">
		<a href="#">Test site!</a>
	</div>
{/if}



{#await checkingToken}
	... checking if you're logged in ... 
{:then}

{#if $location.includes('new_password')}
<div class="m-1">
	<Router {routes} on:routeLoading={console.log}/>
	</div>
{:else if $userID}
	
<span class="ml-3">
	<a href="/SimOrders" use:link use:active={/^\/SimOrders(?!\/(unpaid|pending))/}><Fa icon={faSimCard} /> All SIM Orders</a> |
	<a href="/SimOrders/pending" use:link use:active={/^\/SimOrders\/pending/}><Fa icon={faClipboardList} /> SIM To Ship</a> |||
	
	<a href="/PickupLocations" use:link use:active><Fa icon={faMapMarkedAlt} /> Pickup Locations</a> ||
	<a href="/hotmobile" use:link use:active><Fa icon={faTools} /> Hotmobile API</a> |
	</span>

	<span class="mr-3 float-right"> {$email} (Permissions: {$perms})<button on:click={app.logoutFull}>Logout</button></span>
	<br>

	<div class="m-1">
	<Router {routes} on:routeLoading={console.log}/>
	</div>

{:else}
	<form>
	
	<div class="container">
		<div class="row justify-content-md-center">
			<div class="col-lg-6 col-md-8 col-s-12">
				<h2 class="ff-dunbar">Login to your account</h2>
				</div>
				</div>
			<div class="row mt-3 justify-content-md-center">
			<div class="col-lg-6 col-md-8 col-s-12">
				<label for="account" class="ff-dunbar title-2">Phone #, Email, or SIM #</label><br>
				<input class="form-control" type="email" name="email" id="account" autocomplete="email" placeholder="Phone #, Email, or SIM #" bind:value={account}>
			</div></div>

			<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
				<label for="password" class="ff-dunbar title-2">Password</label>
				<div class="float-right"><a use:link href="/new_password/{account||''}">Forgot Password / Create Password</a></div><br>
				<input class="form-control" type="password" name="password" id="password" autocomplete="current-password" placeholder="Password" bind:value={password}>
			</div></div>
			<div class="row justify-content-md-center">
				<div class="mt-3 col-lg-6 col-md-8 col-s-12">
			<button type="submit" class="btn btn-primary form-control" on:click|preventDefault={login}>Continue <Fa icon={faChevronRight}/></button>
			{#if error}
				<div class="alert alert-danger">
				{error}
				</div>
				{/if}
			</div></div>
		
			<div class="row justify-content-md-center">
				<div class="mt-5 col-lg-6 col-md-8 col-s-12">
				<label class="ff-dunbar title-2" for="newaccount">Don't yet have an account?</label><br>
				<a use:link href="/new_password/{account||''}" id="newaccount" class="btn btn-primary form-control">Create Account <Fa icon={faChevronRight}/></a>
			</div></div>

		</div>
	
		</form>
		
{/if}
{/await}


</main>
